import { TypeDeclaration } from '@common/services';

export const TYPE_DECLARATION_TEXTS: Record<TypeDeclaration, string> = {
  [TypeDeclaration.CONSOLIDEE]: 'Déclaration consolidée',
  [TypeDeclaration.INDIVIDUELLE]: 'Déclaration par établissement',
};